/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/core';
import MuiProvider from './Mui';
import { jsx as ___EmotionJSX } from "@emotion/core";
const emotionCache = createCache({
  key: 'aulaui-next',
  container: typeof document !== 'undefined' && document.getElementById('aulaui-next-insertion-point')
});

const Provider = ({
  theme,
  children
}) => ___EmotionJSX(CacheProvider, {
  value: emotionCache
}, ___EmotionJSX(MuiProvider, {
  theme: theme
}, children));

Provider.defaultProps = {
  theme: null
};
Provider.propTypes = {
  theme: PropTypes.shape({}),
  children: PropTypes.node.isRequired
};
export default Provider;
//# sourceMappingURL=Provider.js.map